<template>
  <div id="app">
    <top></top>
    <router-view class="wrapper"></router-view>
    <footerIndex></footerIndex>
  </div>
</template>

<script>
import top from '@/components/public/top'
import footerIndex from '@/components/public/footer'
export default {
  name: 'App',
  components: {
    top,
    footerIndex
  },
  watch: {
  }
}
</script>

<style>
html,body{font-family: Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif;margin:0;padding:0;}
ul{margin:0;padding:0;list-style:none;outline:none;}
.wrapper a{display:inline-block;margin:0;padding:0;text-decoration:none;outline:none;}
.wrapper a:link,.wrapper a:visited,.wrapper a:hover,.wrapper a:active{text-decoration:none;outline:none;}
.wrapper p,.wrapper dl,.wrapper dd{margin:0;}
.pull-left{float:left!important;}
.pull-right{float:right!important;}
.text-right{text-align:right;}
.no-more{display:block;padding:15px 0;font-size:16px;color:#333;text-align:center;background-color:#fff;}
.alert-mes{position:fixed;top:50%;left:50%;z-index:2000;padding:15px;min-width:180px;max-width:240px;font-size:15px;color:#fff;text-align:center;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background:rgba(0,0,0,0.7);border-radius:5px;}
.el-upload .el-upload__input,.el-upload input[type=file]{display:none;}
.wrapper{background-color:#f5f5f5;overflow:hidden;}
.home-index{margin:0 auto 20px;max-width:1200px;width:100%;overflow:hidden;}
.empty-img{display: block;width:100%;}
.clear{clear:both;}
</style>
